export enum HeaderType { Normal = 'normal', Light = 'light' };